<script>
    import { Link } from 'svelte-routing';
    import TopMenu from '../components/TopMenu.svelte';
    import Header from '../components/Header.svelte';
    import {store} from '../stores.js';

    const axis = store('axis', '', false);
</script>

{#if !$axis}
    <TopMenu title="Нет доступа 🤕" />
{/if}

<div id="appCapsule" class="{$axis ? 'pt-1' : ''}">
    <Header title="Нет доступа 🤕" />
    
    <div class="section">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3 mb-2">
                Вернитесь на <Link to="/">назад</Link>.
            </div>
        </div>
    </div>
</div>
